import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Btn, Card, CardBody, LoadingSpinner, MultilineText } from '@/presentation/component/ui';
import { useCatalog } from '@/presentation/hook/useCatalog';

export const FormationPage = () => {
  const { t } = useTranslation();
  const { categories, isLoading, fetchCategories } = useCatalog();

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  if (isLoading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-[var(--color-ink)] mb-4">
            {t('formation.title')}
          </h1>
          <p className="text-lg sm:text-xl text-[var(--color-ink-soft)] max-w-2xl mx-auto">
            {t('formation.description')}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {categories.map((category) => (
            <Card key={category.id} className="flex flex-col">
              <CardBody className="flex flex-col flex-1">
                <h3 className="text-xl font-semibold text-[var(--color-ink)] mb-2">
                  {category.name}
                </h3>
                <MultilineText className="text-[var(--color-ink-soft)] mb-4 line-clamp-3">
                  {category.description}
                </MultilineText>
                <div className="flex justify-end mt-auto">
                  <Link to={`/category/${category.id}`}>
                    <Btn size="sm" kind="primary">
                      {t('buttons.explore')}
                    </Btn>
                  </Link>
                </div>
              </CardBody>
            </Card>
          ))}
        </div>

        {categories.length === 0 && (
          <div className="text-center py-12">
            <p className="text-[var(--color-ink-faint)] text-lg">{t('formation.noCategories')}</p>
          </div>
        )}
      </div>
    </div>
  );
};
